import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

interface IProps {
  redirect?: string;
  isAuth?: boolean;
  children: ReactNode; 
}

const AuthRoute = ({
  redirect = "/",
  isAuth = false,
  children,
  ...rest
}: IProps) => {
  if (!isAuth) {
    return <Navigate to={redirect} replace />;
  }

  return <>{children}</>; 
};

export default AuthRoute;
